// ============================================================================
// CalendarHero — homepage hero with rotating photo strip + training schedule
// title.
// ============================================================================
// Layout:
//   1. PhotoStrip (6 images, rotates every 8 sec through 30 curated photos)
//   2. "Training Schedule" title
//   3. Workshops · Webinars · Events icon row
//
// No event-specific CTA — the calendar grid below the hero is the primary
// action surface; clicks navigate to per-event detail pages.
//
// Vertical padding kept tight per David's feedback: trimmed from py-16/24
// down to py-6/10 so the green real estate doesn't dominate the fold.
// ============================================================================

import { Calendar, GraduationCap, Video } from 'lucide-react';
import { PhotoStrip } from './PhotoStrip';

export function CalendarHero() {
  return (
    <section className="bg-gradient-to-br from-uif-green to-uif-green-dark text-white">
      <div className="max-w-5xl mx-auto px-4 py-6 md:py-10">
        <PhotoStrip />

        <h1 className="text-3xl md:text-5xl font-bold mt-6 md:mt-8 text-center tracking-tight">
          Training Schedule
        </h1>

        <div className="mt-4 inline-flex w-full items-center justify-center gap-6 text-sm md:text-base text-white/90">
          <span className="inline-flex items-center gap-2">
            <GraduationCap className="h-4 w-4" />
            Workshops
          </span>
          <span className="inline-flex items-center gap-2">
            <Video className="h-4 w-4" />
            Webinars
          </span>
          <span className="inline-flex items-center gap-2">
            <Calendar className="h-4 w-4" />
            Events
          </span>
        </div>
      </div>
    </section>
  );
}
